module.exports = __webpack_public_path__ + "img/gq.91dcdf03.svg";